
  import * as noneRuntime$_7PMr4AAtqc4p15vcLVs_eCvIdDzK26wC98t526UIYQk from '/app/node_modules/@nuxt/image/dist/runtime/providers/none'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "none",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['none']: { provider: noneRuntime$_7PMr4AAtqc4p15vcLVs_eCvIdDzK26wC98t526UIYQk, defaults: {} }
    }
  }
